// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"182":"d99a796317818e55130d","962":"e9201a42cddc873d4a84"}[chunkId] + ".js";
};